module.exports = __webpack_public_path__ + "media/images/marumotakagi/banner-9b15f6d19fe3504559b1b8d246b1a875.gif";